var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhiteSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.827 19.0079L14.9656 14.1476C16.2697 12.6487 17.0592 10.6931 17.0592 8.55559C17.0592 3.85049 13.2313 0.0278778 8.52961 0.0278778C3.82346 0.0278778 0 3.85493 0 8.55559C0 13.2563 3.8279 17.0833 8.52961 17.0833C10.6676 17.0833 12.6236 16.294 14.1229 14.9902L18.9843 19.8505C19.0996 19.9658 19.2548 20.0279 19.4056 20.0279C19.5564 20.0279 19.7117 19.9702 19.827 19.8505C20.0577 19.6199 20.0577 19.2385 19.827 19.0079ZM1.19317 8.55559C1.19317 4.51125 4.48436 1.22522 8.52517 1.22522C12.5704 1.22522 15.8572 4.51568 15.8572 8.55559C15.8572 12.5955 12.5704 15.8904 8.52517 15.8904C4.48436 15.8904 1.19317 12.5999 1.19317 8.55559Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSearch);
export default __webpack_public_path__ + "static/media/white-search.c2a0cfd65737c1aa3fc162b600f8e6fb.svg";
export { ForwardRef as ReactComponent };